import { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { services, serviceCategories } from '@/mocks/services';

const categoryImages: Record<string, string> = {
  'hair-1': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20with%20beautiful%20layered%20haircut%20in%20elegant%20salon%2C%20soft%20warm%20lighting%2C%20minimalist%20interior%2C%20cream%20and%20rose%20tones&width=400&height=300&seq=service-hair-01&orientation=landscape',
  'hair-2': 'https://readdy.ai/api/search-image?query=Korean%20style%20soft%20perm%20wavy%20hair%20on%20young%20asian%20female%20student%2C%20natural%20elegant%20look%2C%20salon%20setting%2C%20warm%20lighting%2C%20clean%20aesthetic&width=400&height=300&seq=service-hair-02&orientation=landscape',
  'hair-3': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20with%20trendy%20gradient%20ombre%20hair%20color%2C%20fashionable%20look%2C%20salon%20interior%2C%20warm%20natural%20lighting%2C%20editorial%20style&width=400&height=300&seq=service-hair-03&orientation=landscape',
  'hair-4': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20college%20student%20with%20silky%20smooth%20straight%20hair%2C%20healthy%20shiny%20look%2C%20salon%20environment%2C%20warm%20cream%20tones%2C%20minimalist%20aesthetic&width=400&height=300&seq=service-hair-04&orientation=landscape',
  'hair-5': 'https://readdy.ai/api/search-image?query=Elegant%20braided%20hairstyle%20on%20young%20asian%20female%20student%2C%20romantic%20look%2C%20salon%20setting%2C%20soft%20natural%20lighting%2C%20warm%20rose%20tones&width=400&height=300&seq=service-hair-05&orientation=landscape',
  'hair-6': 'https://readdy.ai/api/search-image?query=Scalp%20spa%20treatment%20on%20young%20female%20client%20in%20elegant%20salon%2C%20relaxing%20atmosphere%2C%20warm%20lighting%2C%20professional%20care%2C%20minimalist%20interior&width=400&height=300&seq=service-hair-06&orientation=landscape',
  'makeup-1': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20student%20with%20natural%20fresh%20daily%20makeup%20look%2C%20dewy%20skin%2C%20salon%20vanity%20mirror%2C%20warm%20lighting%2C%20clean%20aesthetic&width=400&height=300&seq=service-makeup-01&orientation=landscape',
  'makeup-2': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20with%20romantic%20date%20night%20makeup%2C%20soft%20pink%20tones%2C%20elegant%20look%2C%20salon%20setting%2C%20warm%20glamorous%20lighting&width=400&height=300&seq=service-makeup-02&orientation=landscape',
  'makeup-3': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20college%20graduate%20with%20flawless%20graduation%20makeup%2C%20cap%20and%20gown%2C%20bright%20confident%20smile%2C%20natural%20lighting%2C%20editorial%20portrait&width=400&height=300&seq=service-makeup-03&orientation=landscape',
  'makeup-4': 'https://readdy.ai/api/search-image?query=Stage%20performance%20makeup%20on%20young%20asian%20female%20student%2C%20dramatic%20eye%20look%2C%20stage%20lighting%2C%20vibrant%20colors%2C%20editorial%20photography&width=400&height=300&seq=service-makeup-04&orientation=landscape',
  'skincare-1': 'https://readdy.ai/api/search-image?query=Young%20female%20client%20receiving%20facial%20cleansing%20treatment%20in%20spa%2C%20steam%20machine%2C%20relaxing%20atmosphere%2C%20warm%20cream%20tones%2C%20professional%20skincare%20setting&width=400&height=300&seq=service-skincare-01&orientation=landscape',
  'skincare-2': 'https://readdy.ai/api/search-image?query=Acne%20treatment%20facial%20for%20young%20female%20student%2C%20gentle%20professional%20care%2C%20clean%20bright%20clinic%20setting%2C%20warm%20lighting%2C%20minimalist%20aesthetic&width=400&height=300&seq=service-skincare-02&orientation=landscape',
  'skincare-3': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20with%20bright%20glowing%20skin%20after%20whitening%20facial%20treatment%2C%20radiant%20complexion%2C%20spa%20setting%2C%20warm%20natural%20lighting&width=400&height=300&seq=service-skincare-03&orientation=landscape',
  'skincare-4': 'https://readdy.ai/api/search-image?query=Gentle%20soothing%20facial%20treatment%20for%20sensitive%20skin%20on%20young%20female%2C%20calm%20relaxing%20spa%20atmosphere%2C%20soft%20warm%20lighting%2C%20natural%20products&width=400&height=300&seq=service-skincare-04&orientation=landscape',
  'nails-1': 'https://readdy.ai/api/search-image?query=Classic%20solid%20color%20manicure%20on%20young%20female%20hands%2C%20elegant%20simple%20nude%20polish%2C%20nail%20salon%20table%2C%20warm%20lighting%2C%20minimalist%20aesthetic&width=400&height=300&seq=service-nails-01&orientation=landscape',
  'nails-2': 'https://readdy.ai/api/search-image?query=Korean%20style%20gradient%20ombre%20nails%20on%20elegant%20female%20hands%2C%20soft%20pink%20to%20white%20transition%2C%20nail%20art%20display%2C%20warm%20lighting%2C%20clean%20background&width=400&height=300&seq=service-nails-02&orientation=landscape',
  'nails-3': 'https://readdy.ai/api/search-image?query=Creative%20floral%20nail%20art%20design%20on%20young%20female%20hands%2C%20colorful%20handpainted%20flowers%2C%20nail%20salon%20setting%2C%20warm%20lighting%2C%20editorial%20photography&width=400&height=300&seq=service-nails-03&orientation=landscape',
  'nails-4': 'https://readdy.ai/api/search-image?query=Pedicure%20treatment%20on%20young%20female%20feet%20in%20nail%20spa%2C%20relaxing%20foot%20bath%2C%20elegant%20salon%20setting%2C%20warm%20cream%20tones%2C%20professional%20care&width=400&height=300&seq=service-nails-04&orientation=landscape',
  'package-1': 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20college%20student%20with%20fresh%20haircut%20and%20natural%20makeup%20smiling%2C%20salon%20background%2C%20warm%20lighting%2C%20happy%20confident%20expression&width=400&height=300&seq=service-package-01&orientation=landscape',
  'package-2': 'https://readdy.ai/api/search-image?query=Young%20beautiful%20asian%20female%20with%20wavy%20hair%20and%20romantic%20makeup%20ready%20for%20date%2C%20elegant%20dress%2C%20warm%20evening%20lighting%2C%20editorial%20portrait&width=400&height=300&seq=service-package-02&orientation=landscape',
  'package-3': 'https://readdy.ai/api/search-image?query=College%20graduate%20female%20student%20with%20gorgeous%20hair%20color%20and%20flawless%20makeup%20in%20graduation%20gown%2C%20throwing%20cap%2C%20sunny%20campus%2C%20joyful%20moment&width=400&height=300&seq=service-package-03&orientation=landscape',
  'package-4': 'https://readdy.ai/api/search-image?query=Two%20young%20asian%20female%20best%20friends%20laughing%20together%20after%20salon%20makeover%2C%20beautiful%20hair%20and%20makeup%2C%20warm%20friendly%20atmosphere%2C%20natural%20lighting&width=400&height=300&seq=service-package-04&orientation=landscape',
};

export default function ServicesPage() {
  const { category } = useParams<{ category?: string }>();
  const activeCategory = category || 'all';

  const filteredServices = useMemo(() => {
    if (activeCategory === 'all') return services;
    return services.filter((s) => s.category === activeCategory);
  }, [activeCategory]);

  const activeCategoryName = serviceCategories.find((c) => c.slug === activeCategory)?.name || '全部服务';

  const breadcrumbItems = [
    { name: '首页', path: '/' },
    { name: activeCategoryName },
  ];

  const servicePageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${activeCategoryName} - 女大学生的沙龙室`,
    description: `女大学生的沙龙室${activeCategoryName}服务，校园平价美容，女生专属体验空间。`,
    url: `https://readdy.ai/services/${activeCategory}`,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(servicePageSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <Breadcrumb items={breadcrumbItems} />

        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-12">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {activeCategoryName}
              </h1>
              <p className="mt-2 text-sm text-foreground-600">
                发现最适合你的美丽服务
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 md:mb-10 overflow-x-auto pb-2 flex-wrap">
              {serviceCategories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/services/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-600'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`} />
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filteredServices.map((service) => (
                <div
                  key={service.id}
                  className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-200 hover:bg-background-200/70"
                >
                  <div className="relative w-full h-48 md:h-52 overflow-hidden">
                    <img
                      src={categoryImages[service.id] || ''}
                      alt={service.name}
                      title={service.name}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-3 right-3 bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full">
                      学生价
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full">
                        {service.duration}
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900">
                      {service.name}
                    </h3>
                    <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {service.description}
                    </p>
                    <div className="mt-3 flex items-center justify-between">
                      <div className="flex items-baseline gap-2">
                        <span className="text-lg font-bold text-primary-500">
                          ¥{service.price}
                        </span>
                        <span className="text-xs text-foreground-400 line-through">
                          ¥{service.originalPrice}
                        </span>
                      </div>
                      <Link
                        to="/about"
                        className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
                      >
                        预约体验
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredServices.length === 0 && (
              <div className="text-center py-16">
                <p className="text-foreground-500">该分类暂无服务</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}